
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PiscifunSwordFlyFishingReel() {
  const [scrolled, setScrolled] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const product = {
    name: 'Piscifun Sword Fly Fishing Reel',
    category: 'Fly Fishing Reels',
    rating: 4.7,
    reviewCount: 892,
    affiliateLink: 'https://amzn.to/4s1cFUp',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/90cc426c124a47c26eb4d88f4b78b0e1.jpeg',
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src="https://public.readdy.ai/ai/img_res/da5d92d9-da24-4329-b9e6-d9157d0c3ae6.png" alt="Best Fishing Gear" className="h-12 w-auto" />
              <span className="text-xl font-bold text-gray-900">Best Fishing Gear</span>
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/rods-reels" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Rods &amp; Reels</Link>
              <Link to="/lures-baits" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Lures &amp; Baits</Link>
              <Link to="/fly-fishing" className="font-medium text-[#2B7A9B]">Fly Fishing</Link>
              <Link to="/ice-fishing" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Ice Fishing</Link>
            </div>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-gray-900"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-[#F8F6F3] py-4">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-[#2B7A9B] transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/fly-fishing" className="hover:text-[#2B7A9B] transition-colors">Fly Fishing</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">Piscifun Sword Fly Fishing Reel Review</span>
          </div>
        </div>
      </div>

      {/* Review Header */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center gap-3 mb-4">
            <span className="bg-[#2B7A9B] text-white text-xs font-bold px-3 py-1 rounded-full uppercase">Fly Fishing Reels</span>
            <span className="text-sm text-gray-600">Updated February 08, 2026</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            Piscifun Sword Fly Fishing Reel Review
          </h1>

          <div className="flex items-center gap-6 mb-8">
            <div className="flex items-center gap-2">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill text-xl ${i < Math.floor(product.rating) ? 'text-yellow-400' : i < product.rating ? 'text-yellow-300' : 'text-gray-300'}`}></i>
                ))}
              </div>
              <span className="text-2xl font-bold text-gray-900">{product.rating}</span>
              <span className="text-gray-600">({product.reviewCount.toLocaleString()} reviews)</span>
            </div>
          </div>

          <p className="text-xl text-gray-700 leading-relaxed">
            The Piscifun Sword Fly Fishing Reel is a pre-loaded, precision-engineered fly reel built from CNC-machined 6061-T6 aluminum alloy. Featuring a multi-disc carbon drag system, hard-anodized finish, and a complete line setup ready to fish, it delivers premium performance at an accessible price point for both beginners and experienced fly anglers.
          </p>
        </div>
      </section>

      {/* Product Image & CTA */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <img
                src={product.image}
                alt="Piscifun Sword Fly Fishing Reel - CNC Machined Aluminum with Pre-Loaded Line"
                className="w-full h-auto object-contain"
              />
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Quick Verdict</h2>
              <div className="bg-white rounded-xl p-6 shadow-md mb-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-lg font-semibold text-gray-900">Overall Rating</span>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-lg ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                    <span className="text-xl font-bold text-gray-900">{product.rating}</span>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Build Quality</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 5 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Drag Performance</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 5 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Value</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                </div>

                <a
                  href={product.affiliateLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block w-full bg-[#2B7A9B] text-white py-4 rounded-full font-bold text-center hover:bg-[#236a87] transition-colors whitespace-nowrap"
                >
                  View on Amazon
                </a>
                <p className="text-xs text-gray-500 text-center mt-3 leading-relaxed">
                  As an Amazon Associate, we earn from qualifying purchases at no extra cost to you.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                <p className="text-sm text-gray-700">
                  <strong className="text-gray-900">Best For:</strong> Beginner and intermediate fly anglers seeking a ready-to-fish reel with premium CNC construction and a smooth, reliable drag system
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Overview</h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            The Piscifun Sword Fly Fishing Reel arrives pre-spooled with tapered fly line, 8-strand backing, and a tapered leader — ready to cast straight out of the box. Precision CNC-machined from 6061-T6 aluminum with a lightweight hollow design, it pairs a multi-disc carbon and stainless steel drag system with a one-way clutch bearing for instant, silent engagement. Hard-anodized for lasting corrosion resistance, this reel punches well above its price class.
          </p>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Key Features</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: 'ri-stack-line', title: 'Pre-Loaded Line System', desc: 'Ready to fish out of box' },
              { icon: 'ri-tools-line', title: 'CNC 6061-T6 Aluminum', desc: 'Precision machined body' },
              { icon: 'ri-contrast-drop-2-line', title: 'Multi-Disc Carbon Drag', desc: 'Smooth, instant engagement' },
              { icon: 'ri-shield-check-line', title: 'Hard-Anodized Finish', desc: 'Corrosion & abrasion resistant' },
              { icon: 'ri-flashlight-line', title: 'Lightweight Hollow Design', desc: 'Reduced weight, full strength' },
              { icon: 'ri-refresh-line', title: 'One-Way Clutch Bearing', desc: 'Silent, seamless retrieve' },
              { icon: 'ri-settings-3-line', title: 'Convertible Retrieve', desc: 'Left or right hand setup' },
              { icon: 'ri-water-flash-line', title: 'Weather Durable Build', desc: 'All-condition performance' },
            ].map((feature, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#2B7A9B]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-2xl text-[#2B7A9B]`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What We Love */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">What We Love</h2>
          <div className="space-y-4">
            {[
              'Arrives fully pre-spooled with tapered fly line, 8-strand backing, and tapered leader — no setup hassle, just fish',
              'CNC-machined 6061-T6 aluminum with a hollow design delivers an exceptional strength-to-weight ratio that reduces fatigue on long days',
              'Multi-disc carbon and stainless steel drag with one-way clutch bearing provides instant, precise engagement and whisper-quiet retrieves',
              'Hard-anodized surface treatment offers superior abrasion and corrosion resistance, keeping the reel performing season after season',
              'Convertible left-to-right retrieve configuration means it works for any angler, with manufacturer support available for the swap'
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-[#F8F6F3] rounded-xl p-6">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <p className="text-lg text-gray-700 pt-1">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Things to Consider */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Things to Consider</h2>
          <div className="space-y-4">
            {[
              'Switching from left to right-hand retrieve requires contacting the manufacturer rather than a simple field adjustment',
              'The pre-loaded line weight is fixed, so anglers who prefer a custom line setup will need to re-spool with their preferred configuration'
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-6 border-2 border-orange-200">
                <div className="w-8 h-8 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-white text-lg"></i>
                </div>
                <p className="text-lg text-gray-700 pt-1">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Verdict */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Verdict</h2>
          <div className="bg-[#2B7A9B]/5 border-l-4 border-[#2B7A9B] rounded-xl p-8">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              The Piscifun Sword Fly Fishing Reel is an outstanding value for anglers who want a ready-to-fish setup without sacrificing build quality or drag performance. Its pre-loaded line system eliminates setup hassles while the precision CNC aluminum body and multi-disc carbon drag deliver performance that rivals reels costing significantly more. Whether you're wading a mountain stream or casting on a stillwater lake, the Sword's combination of lightweight durability, corrosion resistance, and silky-smooth operation makes it a reliable companion for seasons to come.
            </p>
            <div className="flex items-center justify-between pt-6 border-t border-gray-300">
              <div>
                <p className="text-sm text-gray-600 mb-2">Final Rating</p>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-2xl ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-3xl font-bold text-gray-900">{product.rating}/5</span>
                </div>
              </div>
              <a
                href={product.affiliateLink}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="bg-[#2B7A9B] text-white px-8 py-4 rounded-full font-bold hover:bg-[#236a87] transition-colors whitespace-nowrap"
              >
                Check Price on Amazon
              </a>
            </div>
            <p className="text-xs text-gray-500 text-center mt-4 leading-relaxed">
              As an Amazon Associate, we earn from qualifying purchases at no extra cost to you.
            </p>
          </div>
        </div>
      </section>

      {/* Related Reviews */}
      <section className="py-16 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-10">Related Reviews</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link to="/fly-fishing/lamson-liquid-s-series-hd-fly-fishing-reel" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-white overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/f482288f9e695c6de0eb48578d4802af.jpg"
                  alt="Lamson Liquid S-Series HD Fly Fishing Reel"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Fly Fishing Reels</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">Lamson Liquid S-Series HD Fly Fishing Reel</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(412)</span>
                </div>
              </div>
            </Link>

            <Link to="/fly-fishing/sf-fly-fishing-line" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-white overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/4424a4ec99d6187dadbbc39518602183.jpeg"
                  alt="SF Fly Fishing Line"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Fly Fishing Lines</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">SF Fly Fishing Line</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : i === 4 ? 'text-yellow-300' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(634)</span>
                </div>
              </div>
            </Link>

            <Link to="/fly-fishing/moonshine-rod-co-fly-fishing-rod" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-white overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/6c4723ef1839f66b40896546f55f9e46.jpeg"
                  alt="Moonshine Rod Co. Fly Fishing Rod"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Fly Fishing Rods</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">Moonshine Rod Co. Fly Fishing Rod</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-yellow-400"></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(634)</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A3A52] text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-4xl font-bold mb-10">BEST FISHING GEAR</h3>
              <p className="text-white/70 leading-relaxed mb-8">
                Your trusted source for honest fishing gear reviews and expert recommendations.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-youtube-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-facebook-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-pinterest-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-widest mb-6">Quick Links</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-white/70 hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/rods-reels" className="text-white/70 hover:text-white transition-colors">Rods &amp; Reels</Link></li>
                <li><Link to="/lures-baits" className="text-white/70 hover:text-white transition-colors">Lures &amp; Baits</Link></li>
                <li><Link to="/fly-fishing" className="text-white/70 hover:text-white transition-colors">Fly Fishing</Link></li>
                <li><Link to="/ice-fishing" className="text-white/70 hover:text-white transition-colors">Ice Fishing</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-widest mb-6">Newsletter</h4>
              <p className="text-white/70 mb-4">Get weekly gear reviews and fishing tips</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/50 text-sm"
                />
                <button className="bg-[#2B7A9B] px-6 py-3 rounded-lg font-semibold hover:bg-[#236a87] transition-colors whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-white/60 text-sm">
                &copy; 2026 BestFishingGear.ca | Amazon Affiliate Disclosure
              </p>
              <div className="flex items-center gap-6 text-white/60 text-sm">
                <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
                <span>|</span>
                <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
                <span>|</span>
                <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link>
                <span>|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
